<template>
  <div class="username-input">
    <div class="form-group" v-bind:class="{ 'has-feedback' : field.dirty }">
      <label v-bind:for="field.name" class="col-sm-4 control-label has-icon has-icon-username">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <input v-bind:id="field.name" class="form-control" type="text" v-model="field.value" v-bind:name="field.name" debounce="500"/>
        <span class="form-validation-info" v-show="loading">Checking if {{ field.label }} is already in use...</span>
        <span class="form-validation-error" v-show="!isLength && field.dirty">{{ field.label }} is too short.</span>
        <span class="form-validation-error" v-show="!isRegex && field.dirty">{{ field.label }} may only contain letters, numbers, single consecutive full stops and underscores.</span>
        <span class="form-validation-error" v-show="field.unique && isLength && !isUnique && field.dirty">{{ field.label }} is already in use. Please select a unique username</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success" v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error" v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UsernameInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false,
          unique: false
        }
      }
    }
  },
  data () {
    return {
      isUnique: true,
      isLength: true,
      loading: false,
      isRegex: true
    }
  },
  ready () {
    if (this.field.value && this.field.unique) {
      this.loading = true
      this.$http.post('public/unique-username', {username: this.field.value}).then(({data}, status, request) => {
        this.loading = false
        this.isUnique = this.field.valid = data.unique
      }).catch(err => {
        this.isUnique = false
        this.field.valid = false
        console.log(err)
      })
    }
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.field.dirty = true
      this.isLength = this.field.valid = newVal.length > 0
      this.isRegex = this.field.valid = !new RegExp(/[^a-zA-Z0-9@_.-]|\.{2,}/).test(newVal)
      if (this.field.unique && this.isLength && this.isRegex) {
        this.loading = true
        this.$http.post('public/unique-username', {username: newVal}).then(({data}, status, request) => {
          this.loading = false
          this.isUnique = this.field.valid = data.unique
        }).catch(err => {
          this.isUnique = false
          this.field.valid = false
          console.log(err)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// UsernameInput.vue?4d852e9f